import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useCanvasId from '../../../../../utils/useCanvasId.js';
import ColumnRenderer from './ColumnRenderer.js';

var reorder = function reorder(list, startIndex, endIndex, rowGroupedColumns) {
  var result = Array.from(list);
  var _result$splice = result.splice(startIndex, 1),
    _result$splice2 = _slicedToArray(_result$splice, 1),
    removed = _result$splice2[0];
  result.splice(endIndex, 0, removed);
  return [].concat(_toConsumableArray(rowGroupedColumns), result);
};
var ColumnList = function ColumnList(_ref) {
  var dataTestId = _ref.dataTestId,
    idProp = _ref.id,
    disableReorder = _ref.disableReorder,
    columns = _ref.columns,
    allowPinning = _ref.allowPinning,
    onReorder = _ref.onReorder;
  var filteredColumns = columns.filter(function (c) {
    var _c$isFiltered;
    return ((_c$isFiltered = c.isFiltered) !== null && _c$isFiltered !== void 0 ? _c$isFiltered : true) && !c.rowGroup;
  });
  var rowGroupedColumns = columns.filter(function (c) {
    return c.rowGroup;
  });
  var id = useCanvasId(idProp);
  var handleDragEnd = function handleDragEnd(result) {
    if (!result.destination) {
      return;
    }
    onReorder(reorder(_toConsumableArray(filteredColumns), result.source.index, result.destination.index, rowGroupedColumns));
  };
  var noMatchingColumns = columns.length === 0;
  return /*#__PURE__*/React__default.createElement(DragDropContext, {
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/React__default.createElement(Droppable, {
    droppableId: id
  }, function (provided, snapshot) {
    return /*#__PURE__*/React__default.createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef,
      className: "C-ColumnManager__List"
    }), noMatchingColumns && /*#__PURE__*/React__default.createElement("p", null, "No matching columns found."), filteredColumns.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement(Draggable, {
        isDragDisabled: disableReorder,
        key: item.field,
        draggableId: item.field,
        index: index
      }, function (provided) {
        return /*#__PURE__*/React__default.createElement(ColumnRenderer, {
          dataTestId: "".concat(dataTestId, "_column_").concat(item.field),
          innerRef: provided.innerRef,
          key: item.field,
          column: item,
          dragHandle: provided.dragHandleProps,
          draggableProps: provided.draggableProps,
          allowPinning: allowPinning
        });
      });
    }), provided.placeholder);
  }));
};

export { ColumnList as default };
